var AttributesList = React.createClass({
  propTypes: {
    attributeSetName: React.PropTypes.string,
    attributes: React.PropTypes.array.isRequired,
    selectedAttributeKeys: React.PropTypes.array,
    showClear: React.PropTypes.bool,
    onAttributesChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedAttributeKeys: []
    }
  },
  clearClicked() {
    if (this.props.onAttributesChanged) {
      this.props.onAttributesChanged("", []);
    }
  },
  attributeValueClicked(attrKey) {
    let selectedAttributeKeys = this.props.selectedAttributeKeys;
    let isSelected = this.isAttributeSelected(attrKey);

    if (!isSelected) {
      selectedAttributeKeys.push(attrKey);
    } else {
      selectedAttributeKeys = selectedAttributeKeys.filter(key => key != attrKey);
    }

    if (this.props.onAttributesChanged) {
      this.props.onAttributesChanged(this.props.attributeSetName, selectedAttributeKeys);
    }
  },
  isAttributeSelected(attrKey) {
    return this.props.selectedAttributeKeys.indexOf(attrKey) != -1;
  },
  getAttributeItems(attr) {
    let items = [];

    items.push(<li className="filter__item -in1" key={attr.name}>{attr.name}</li>);

    items = items.concat(attr.values.map(valueInfo => {
      let key = attr.name + "rasplit" + valueInfo.value;

      return (
        <li className="filter__item -in2" key={key}>
          <RACheck label={valueInfo.value}
            value={key}
            isChecked={this.isAttributeSelected(key)}
            onClick={this.attributeValueClicked} />
        </li>
      )
    }));

    return items;
  },

  render() {
    let clearItem = this.props.showClear ?
      <li className="filter__item"><a href="#" onClick={this.clearClicked}>{Labels.getLabel("Clear")}</a></li> : null;

    return (
      <ul className="filter__list">
        {clearItem}
        <li className="filter__item -active">{this.props.attributeSetName}</li>
        {this.props.attributes.map(this.getAttributeItems)}
      </ul>
    )
  }
});